/* src/app/Home.js */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Redirect, Route, Switch } from 'react-router-dom';
import { isEmpty } from 'lodash';
import localforage from 'localforage';

import { ComingSoonPage, Content, ErrorBar, Sidebar } from './components';
import PageNotFound from './PageNotFound';
import { ProfileScene } from '../modules/profile';
import { Program } from '../modules/program';
import StudentCard from '../modules/students/cards/StudentCard';
import routes from './routes';

import { clearError } from '../modules/app_state/actions';
import { getNotificationToken, onTokenRefresh } from '../config/firebase';
import { modifyUser } from '../modules/profile/actions';

class Home extends React.Component {
  async componentDidMount() {
    if (global.browserName !== 'Safari') {
      await Notification.requestPermission();
      if (Notification.permission === 'granted') {
        const token = await getNotificationToken();
        this.props.modifyUser({ userUpdateInput: { device_token: token } });
      }
    }
    onTokenRefresh(async () => {
      const token = await getNotificationToken();
      this.props.modifyUser({ userUpdateInput: { device_token: token } });
    });
  }

  render() {
    const { match, open, onClose, errorMessage, clearError: clear } = this.props;
    const { url } = match;
    return (
      <React.Fragment>
        <Sidebar match={match} open={open} onClose={onClose} />
        <Content open={open}>
          <Switch>
            <Redirect exact from={url} to={`${url}/dashboard`} />
            <Route
              path={`${url}/profile`}
              render={props => (
                <ProfileScene {...props} open={open} />
              )}
            />
            <Route
              path={`${url}/subsidy/program`}
              render={props => (
                <Program {...props} open={open} />
              )}
            />
            <Route
              path={`${url}/students/student`}
              render={props => (
                <StudentCard {...props} open={open} />
              )}
            />
            {routes.map(prop => (
              <Route
                path={`${url}${prop.path}`}
                render={props => (
                  <React.Fragment>
                    <prop.scene {...props} open={open} />
                    {!prop.ready && process.env.NODE_ENV !== 'development' && (
                      <ComingSoonPage />
                    )}
                  </React.Fragment>
                )}
                key={prop.text}
              />
            ))}
            <Route component={PageNotFound} />
          </Switch>
          <ErrorBar
            open={!isEmpty(errorMessage)}
            onClose={clear}
            message={errorMessage}
          />
        </Content>
      </React.Fragment>
    );
  }
}

Home.propTypes = {
  match: PropTypes.object.isRequired,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  errorMessage: PropTypes.string,
  clearError: PropTypes.func.isRequired,
};

Home.defaultProps = {
  errorMessage: '',
};

const mapStateToProps = state => ({
  errorMessage: state.appState.error.code || state.appState.error.message,
  userId: state.auth.data.user._id,
});

const mapDispatchToProps = dispatch => ({
  clearError: () => dispatch(clearError()),
  modifyUser: params => dispatch(modifyUser(params)()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Home);



// WEBPACK FOOTER //
// ./src/app/Home.js